export default __webpack_public_path__ + "static/media/ExerApp-Thumbnail.66102323.png";